import { z } from 'zod';
import { validatePersonalIdentificationNumber } from '@/utils/validation';

/**
 * Schema which validates that given string value is
 * numeric integer type. It accepts zero padded values.
 */
export const NumericStringIntegerSchema = z.string().regex(/^\d+$/);

/**
 * Schema which validates that given string value is
 * numeric float type. It accepts zero padded values.
 */
export const NumericStringFloatSchema = z.string().regex(/^\d+\.\d+$/);

/**
 * Schema which validates that given string value is
 * numeric integer or float type. It accepts zero padded values.
 */
export const NumericStringSchema = z.union([NumericStringIntegerSchema, NumericStringFloatSchema]);

/**
 * Schema which validates finnish postal codes.
 */
export const PostalCodeSchema = z.string().regex(/^[0-9]{5}$/);

/**
 * Schema which validates finnish social security numbers.
 * Schema accepts "9" series SSN's.
 */
export const SsnSchema = z.custom<string>((val) => {
  return validatePersonalIdentificationNumber(val);
});

/**
 * Schema which accepts number value or numeric strings
 * either in integer or float presentation and it (if needed)
 * coerces the value into number using Number.parseInt().
 */
export const CoerceToNumberSchema = z.union([z.number(), NumericStringSchema.transform((val) => Number.parseInt(val))]);

/**
 * Schema that accepts boolean true or false and strings 'true' or 'false'
 * and coerces the value into boolean.
 */
export const CoerceToBooleanSchema = z
  .union([z.boolean(), z.literal('true'), z.literal('false')])
  .transform((value) => value === true || value === 'true');
